export default __webpack_public_path__ + "static/media/LuckiestGuy-Regular.04dea529.ttf";